import React, { useState, useEffect } from 'react';

const GoogleReviewsWidget = ({ placeId, maxReviews = 1, minRating = 4 }) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fallback data for development/demo purposes
  const fallbackReviews = [
    {
      author_name: "Maria Schmidt",
      rating: 5,
      text: "Ausgezeichnete Beratung und wunderschöne Pflanzen! Das Personal ist sehr freundlich und hilfsbereit. Meine Zimmerpflanzen gedeihen prächtig seit dem Kauf hier.",
      profile_photo_url: "./../images/Vector (1).png",
      time: Date.now() - 86400000 // 1 day ago
    },
    {
      author_name: "Thomas Weber",
      rating: 5,
      text: "Großartige Auswahl an Pflanzen und Gartenzubehör. Die Beratung zur Pflanzenpflege war sehr hilfreich. Komme gerne wieder!",
      profile_photo_url: "./../images/Vector (1).png",
      time: Date.now() - 172800000 // 2 days ago
    },
    {
      author_name: "Sarah Müller",
      rating: 4,
      text: "Schöner Laden mit frischen Blumen und gesunden Pflanzen. Die saisonalen Dekorationen sind besonders empfehlenswert.",
      profile_photo_url: "./../images/Vector (1).png",
      time: Date.now() - 259200000 // 3 days ago
    }
  ];

  useEffect(() => {
    const fetchGoogleReviews = async () => {
      try {
        setLoading(true);
        
        // Check if Google Places API key is configured
        const apiKey = 'AIzaSyB84hq9Mx8l7EWIAKX13QyPTTz6tWBxAhA';
        
        if (!apiKey || !placeId) {
          // Use fallback data if no API key or place ID
          console.log('Using fallback reviews - Google Places API not configured');
          const filteredReviews = fallbackReviews
            .filter(review => review.rating >= minRating)
            .slice(0, maxReviews);
          setReviews(filteredReviews);
          setLoading(false);
          return;
        }

        // Fetch reviews from Google Places API
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=reviews&key=${apiKey}`
        );

        if (!response.ok) {
          throw new Error('Failed to fetch reviews');
        }

        const data = await response.json();
        
        if (data.status === 'OK' && data.result && data.result.reviews) {
          const filteredReviews = data.result.reviews
            .filter(review => review.rating >= minRating)
            .slice(0, maxReviews);
          
          setReviews(filteredReviews);
        } else {
          throw new Error('No reviews found or API error');
        }
      } catch (err) {
        console.error('Error fetching Google reviews:', err);
        // Fallback to demo data on error
        const filteredReviews = fallbackReviews
          .filter(review => review.rating >= minRating)
          .slice(0, maxReviews);
        setReviews(filteredReviews);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGoogleReviews();
  }, [placeId, maxReviews, minRating]);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <img 
        key={index}
        src="./../images/star 5.png" 
        alt="star" 
        style={{ 
          opacity: index < rating ? 1 : 0.3,
          width: '16px',
          height: '16px',
          marginRight: '2px'
        }}
      />
    ));
  };

  if (loading) {
    return (
      <div className="wrapper__card-head-profile">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <div className="spinner-border text-success" role="status">
            <span className="sr-only">Loading reviews...</span>
          </div>
        </div>
      </div>
    );
  }

  if (reviews.length === 0) {
    return (
      <div className="wrapper__card-head-profile">
        <div className="rating d-flex align-items-center mb-4">
          {renderStars(5)}
        </div>
        <h3 className="semi-bold font__size--16 text__16-1024">Hervorragende Pflanzenberatung</h3>
        <p className="normal font__size--12 text__12-1024 color__gray-1">
          Besuchen Sie uns für eine persönliche Beratung zu Ihren Lieblingspflanzen.
        </p>
        <div className="d-flex align-items-center profile">
          <img src="./../images/Vector (1).png" alt="profile" />
          <h5 className="mb-0 ml-2 normal font__size--16 text__16-1024">Bloom Team</h5>
        </div>
      </div>
    );
  }

  // Display the first (most relevant) review
  const review = reviews[0];

  return (
    <div className="wrapper__card-head-profile">
      <div className="rating d-flex align-items-center mb-4">
        {renderStars(review.rating)}
      </div>
      <h3 className="semi-bold font__size--16 text__16-1024">
        {review.rating === 5 ? 'Ausgezeichnete Beratung' : 'Sehr gute Erfahrung'}
      </h3>
      <p className="normal font__size--12 text__12-1024 color__gray-1">
        {review.text.length > 150 ? `${review.text.substring(0, 150)}...` : review.text}
      </p>
      
      <div className="d-flex align-items-center profile">
        <img src={review.profile_photo_url || "./../images/Vector (1).png"} alt="profile" />
        <h5 className="mb-0 ml-2 normal font__size--16 text__16-1024">{review.author_name}</h5>
      </div>
      
      {error && (
        <small className="text-muted mt-2 d-block">
          Demo-Bewertung angezeigt
        </small>
      )}
    </div>
  );
};

export default GoogleReviewsWidget;